import { styled } from "styled-components";

export const TextCounterContainer = styled.div<{
  $isCounterVisible: boolean;
}>`
  position: absolute;
  top: 100%;
  z-index: 10;
  transform: translate(5px, 0);
  display: flex;
  opacity: ${({ $isCounterVisible }) => ($isCounterVisible ? 1 : 0)};
  visibility: ${({ $isCounterVisible }) =>
    $isCounterVisible ? "visible" : "hidden"};
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  pointer-events: none;
  > div {
    pointer-events: all;
  }
`;
